export default function RestaurantWeeksScreenshot(){
    return(
        <img src='restaurant-weeks-nov.jpg' style={{maxWidth:'100%'}} />
    )
}